import React from "react";
import styles from "./bar.module.scss";

export const BarDateHandle = ({
  x,
  y,
  width,
  height,
  barCornerRadius,
  onMouseDown
}) => {
  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      className={styles.barHandle}
      ry={barCornerRadius}
      rx={barCornerRadius}
      onMouseDown={onMouseDown}
    />
  );
};
